module.exports = __webpack_public_path__ + "static/assets/2a8ac4ccba25ba522bd64e98d39db70e.svg";